<template>
  <div class="top page-section" :style="{ paddingTop: addPadding ? '45px' : '0px', paddingBottom: '0px' }">
    <h1 class="info-title white padding-top-60">
      Put your money to work with
      <br />
      <b>smarter savings</b>
    </h1>
    <p class="section-subtitle">
      <b>Your savings outlook:</b>
      <br />
      Saving <b>£{{ numberToHumanReadable(monthlySavings) }} monthly</b>, based on a 2.5% AER, in 12 months could become:
    </p>
    <div class="breakdown-table">
      <div class="breakdown-content">
        <div class="breakdown-row">
          <div class="col savings-value">
            £{{ numberToHumanReadable(depositsValue) }}
          </div>
          <div class="col savings-label">
            in deposits value
          </div>
        </div>

        <div class="breakdown-row">
          <div class="col savings-value">
            £{{ numberToHumanReadable(interestEarned) }}
          </div>
          <div class="col savings-label">
            in interest earned
          </div>
        </div>

        <div class="breakdown-row breakdown-total-row">
          <div class="col savings-value">
            £{{ numberToHumanReadable(totalSavingsValue) }}
          </div>
          <div class="col savings-label">
            total saving value
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { numberToHumanReadable } from '../../../../utils/miscUtils';

const props = defineProps({
  monthlyAvgDisposableIncome: {
    type: Object,
    required: true,
  },
  addPadding: {
    type: Boolean,
    default: true,
  },
});

const monthlySavings = computed(() => props.monthlyAvgDisposableIncome.total);
const depositsValue = computed(() => monthlySavings.value * 12);
const interestEarned = computed(() => depositsValue.value * 0.025); // 2.5% AER
const totalSavingsValue = computed(() => depositsValue.value + interestEarned.value);

</script>

<style lang="scss" scoped>
@import '../../../../scss/riseup-vars';

.top {
  padding-bottom: 45px;
}

.info-title {
  font-size: 36px;
  font-family: 'SalaryFinance';
  padding-top: 40px;
  padding-right: 25px;
  margin-bottom: 20px;
  text-align: left;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  font-weight: 100 !important;
  line-height: 1;
}

.white {
  color: #FFFFFF;
}

.info-title b {
  font-weight: 700;
}

.section-subtitle {
  font-size: 17px;
  font-family: 'SalaryFinance';
  margin-top: 25px;
  margin-bottom: 40px;
  text-align: left;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.5;
}

.light-blue-button {
  background: #2C82FF;
  box-shadow: 0px 4px 21px rgba(149.13, 152.94, 149.88, 0.56);
  border-radius: 12px;
  color: white;
  padding: 17px 0px;
  border: none;
  width: 100%;
  cursor: pointer;
  font-size: 18px;
  font-family: 'SalaryFinance';
  font-weight: 700;
  margin-top: 15px;
  margin-bottom: 10px;
  margin-left: auto;
  margin-right: auto;
  display: block;
  padding-top: 16px;
  padding-bottom: 18px;
}

.breakdown-table {
  width: 90%;
  background-color: white;
  box-shadow: 0px 16px 46.4px 0px #00000026;
  border-radius: 25px;
  padding: 25px;
  margin-top: 20px;
  z-index: 2;
  margin: 0 auto;
  position: relative;
  padding-top: 30px;
}

.breakdown-content {
  width: 100%;
}

.breakdown-row {
  display: flex;
  padding: 15px 5px;
  border-bottom: 1px solid rgba(32, 84, 65, 0.2);
  font-family: 'SalaryFinance';

  &:last-child {
    border-bottom: none;
  }
}

.col {
  color: #0C3467;

  &.savings-label {
    flex: 4;
    font-size: 17px;
    padding-left: 15px;
    padding-top: 5px;
  }

  &.savings-value {
    flex: 1;
    font-weight: 700;
    text-align: left;
    color: #2FB153;
    font-size: 25px;
  }
}

.breakdown-total-row {
  font-weight: 100;
}

.breakdown-total-row b {
  font-weight: 700;
}

.padding-top-60 {
  padding-top: 60px;
}

</style>
